import React from 'react';
import { convertPropToCssClassName } from '@elliemae/ds-classnames';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const SvgIcon = (props: SvgIconT.Props) => {
  const { containerProps = {}, size, color, className = '', style = {}, innerRef, ...rest } = props;
  const fill = !color && !props.fill ? '#FFF' : props.fill;
  const width = !size && !props.width ? 35 : props.width;
  const height = !size && !props.height ? 35 : props.height;
  const { cssClassName } = convertPropToCssClassName('icon', className, {
    size,
    color,
  });
  return (
    <span
      ref={innerRef}
      className={cssClassName}
      {...rest}
      {...containerProps}
      style={{
        width,
        height,
        ...style,
      }}
    >
      <svg
        width={width && String(width)}
        height={height && String(height)}
        style={{
          width,
          height,
        }}
        fill={fill}
        viewBox="0 0 35 35"
      >
        <g fill="none" fillRule="evenodd">
          <path
            d="M22.085 23.97c1.15 0 2.145.295 2.645.545l.1.05-.505 1.705-.145-.085c-.38-.215-1.045-.47-2.1-.47-1.075 0-1.97.375-2.59 1.11-.575.665-.895 1.605-.895 2.655 0 2.215 1.38 3.705 3.43 3.705 1.015 0 1.685-.26 2.235-.5l.145-.065.375 1.65-.09.045c-.56.29-1.68.63-3.01.63-1.55 0-2.865-.52-3.81-1.495-.935-.965-1.43-2.315-1.43-3.895 0-1.585.545-3.005 1.54-4.005 1.025-1.035 2.445-1.58 4.105-1.58zm-7.325.44v10.525h-2.13V24.41h2.13zm15.715-.47c1.515 0 2.72.615 3.485 1.77.8 1.215.89 2.64.89 3.2 0 .335-.03.605-.055.8l-.025.2h-7.19c.04 1.08.385 1.92 1.025 2.495.585.525 1.4.8 2.355.8 1.375 0 2.155-.25 2.79-.52l.145-.06.38 1.595-.1.045c-.675.305-1.82.67-3.465.67-1.57 0-2.89-.515-3.805-1.48-.9-.945-1.375-2.275-1.375-3.85 0-1.565.465-2.99 1.315-4.01.9-1.08 2.155-1.655 3.63-1.655zm-.145 1.605c-1.81 0-2.545 1.675-2.715 2.77h5.165c-.01-.45-.105-1.455-.77-2.13-.415-.425-.98-.64-1.68-.64z"
            fill="#FFF"
          />
          <path fill="#8DC7E9" d="M0 0v34.935h6.925v-3.19H3.19V3.19h28.555v15.695h3.195V0z" />
        </g>
      </svg>
    </span>
  );
};

export default SvgIcon;
